import { useEffect, useState } from 'react';

import { PropTypes } from 'prop-types';

import {
  Badge,
  Box,
  Checkbox,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import { toSentenceCase } from '../../../utils';

const BadgeComponent = ({ number }) => {
  const { t } = useTransl();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <Typography sx={{ margin: 0, padding: 0 }}>
        {t('community.options')}
      </Typography>
      <Box sx={{ marginRight: '10px' }}>
        <Badge badgeContent={number} color="primary" />
      </Box>
    </Box>
  );
};

const ApprovalsDropDown = ({ options, approvalScope, onCommunityUpdate }) => {
  const [selectedOptions, setSelectedOptions] = useState(approvalScope);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    onCommunityUpdate(value);
  };

  useEffect(() => {
    setSelectedOptions(approvalScope);
  }, [approvalScope]);

  const MenuProps = {
    PaperProps: {
      style: {
        borderRadius: 10,
        boxShadow: 'none',
        border: '1px solid #CFCFCF',
      },
    },
  };

  return (
    <div>
      <FormControl sx={{ minWidth: '15rem', padding: '0' }} size="small">
        <Select
          multiple
          value={selectedOptions}
          displayEmpty
          onChange={handleChange}
          variant="outlined"
          renderValue={() => <BadgeComponent number={selectedOptions.length} />}
          MenuProps={MenuProps}
        >
          {options?.map((item) => (
            <MenuItem key={item} value={item} dense>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexDirection: 'row',
                  alignItems: 'center',
                  padding: 0,
                }}
              >
                <Checkbox checked={!!selectedOptions.includes(item)} />
                <Typography>{toSentenceCase(item)}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

ApprovalsDropDown.propTypes = {
  options: PropTypes.instanceOf(Array).isRequired,
  approvalScope: PropTypes.instanceOf(Array).isRequired,
  onCommunityUpdate: PropTypes.func.isRequired,
};

BadgeComponent.propTypes = {
  number: PropTypes.number.isRequired,
};

export default ApprovalsDropDown;
